import { Box, Center, Link } from '@chakra-ui/react';
import React from 'react';
import { FaFacebook, FaGoogle, FaLinkedin, FaTwitter, FaYoutube } from 'react-icons/fa';

export interface SocialMediaLinkProps {
    platform: 'LinkedIn' | 'Facebook' | 'Twitter' | 'YouTube' | 'Google+';
    to?: string;
};

const SocialMediaLink = (props: SocialMediaLinkProps) => {

    let platformIcon;
    
    switch (props.platform) {
        case 'LinkedIn':
            platformIcon = <FaLinkedin />
            break;
        case 'Facebook':
            platformIcon = <FaFacebook />
            break;
        case 'Google+':
            platformIcon = <FaGoogle />
            break;
        case 'Twitter': 
            platformIcon = <FaTwitter />
            break;
        case 'YouTube': 
            platformIcon = <FaYoutube />
            break;
        default:
            break;
    };

    return (
        <Link display='flex' flex='1' marginBottom='5px' href={ props.to }>
            <Center>
                <Box marginRight='5px'>
                    { platformIcon }
                </Box>
                { props.platform }
            </Center>
        </Link>
    ) ;
};

export default SocialMediaLink;